import {Option} from '@/pages/LogicTestIrt/components/Options/types';

export const shuffle = (a: Option[]): Option[] => {
    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
};
